import { render, staticRenderFns } from "./IconLsSlider.vue?vue&type=template&id=96a6ed68"
import script from "./IconLsSlider.vue?vue&type=script&lang=js"
export * from "./IconLsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports